module.exports = __webpack_public_path__ + "36982110fd6e7415bcf9f0d4320fb9fa.svg";